import L from "leaflet";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "../../../store/store";
import { RenderBar } from "../WeatherBar/RenderBar";

const CustomContainer = ({ map }) => {
  


  return (
    <div className="leaflet-bar custom-container">
      <Provider store={store}>
        <RenderBar />
      </Provider>
      <div id="zoom-control-container"></div>
    </div>
  );
};

export const createCustomContainer = (map) => {
  L.Control.CustomContainer = L.Control.extend({
    onAdd: function () {
      const div = L.DomUtil.create("div", "leaflet-bar custom-container");

      ReactDOM.render(<CustomContainer map={map} />, div);

      return div;
    },
  });

  L.control.customContainer = function (opts) {
    return new L.Control.CustomContainer(opts);
  };
};
